import { ErrorPage } from 'requiro-ui-theme';
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { errorGenerator } from '../../lib/errorGenerator';
import { generatoreCode } from 'lib/generateCode';
import { stateError } from './stateError';

class ErrorBoundary extends React.Component<IProps, IErrorBoundaryState> {
  state = stateError;

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    const { t } = this.props;
    const isGenericErrror = !(
      error &&
      error.code &&
      error.code.text &&
      error.code.text.length === 8
    );

    const errorCode = !isGenericErrror
      ? error.code.text
      : generatoreCode(8).toString();

    isGenericErrror &&
      errorGenerator(
        errorCode,
        error,
        'componentError',
        'Un componente è andato in errore',
      );
    this.setState((prevState) => ({
      ...prevState,
      message: error.message,
      section: error.name,
      code: { text: errorCode } ?? { text: '404' },
      title: error.title ?? { text: t('titleErrorPage') },
      button: error.button ?? { text: t('textButtonErrorPage') },
      problem: error.problem ?? {
        text: t('textProblemErrorPage'),
        link: t('linkProblemErrorPage'),
      },
    }));
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorPage
          code={this.state.code}
          title={this.state.title}
          button={this.state.button}
          problem={this.state.problem}
        />
      );
    }

    return this.props.children;
  }
}

interface IProps extends WithTranslation {
  // prop: any;
}

interface IErrorBoundaryState {
  hasError: boolean;
  message: string;
  section: string;
  code: object;
  title: object;
  button: object;
  problem: object;
}

export default withTranslation()(ErrorBoundary);
